export default (ctx, inject) => {
  let instance;

  inject('modal', {
    setInstance(ref) {
      instance = ref;
    },
    create(modal) {
      if (!instance) {
        return Promise.reject();
      }

      return instance.create(modal);
    },
    remove(id) {
      if (!instance) {
        return;
      }

      return instance.remove(id);
    },
  });
};
